var _rect, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPayByBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 150 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 150,
  height: 40,
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A2E",
  stroke: "#1A1A2E",
  d: "m16 10 10-4 10 4v4H16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A2E",
  d: "M18 16h4v10h-4zM24 16h4v10h-4zM30 16h4v10h-4zM15 27h22v3H15z"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 46,
  y: 25,
  fill: "#1A1A2E",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 13,
  fontWeight: "bold"
}, "Pay by Bank")));
export { SvgPayByBank as ReactComponent };
export default __webpack_public_path__ + "PayByBank.59f1630a.svg";